module.exports = __webpack_public_path__ + "img/danger.6d0df867.svg";